
<template>
    <ul id="nav">
        <li><router-link to="/">Home</router-link></li>
        <li><router-link to="/contact">Contact</router-link></li>
        <!-- <li><router-link to="/gallery">Gallery</router-link></li> -->
    </ul>
</template>

<script>
  export default {
    name: 'SiteNav',
  };
</script>